export default __webpack_public_path__ + "static/media/backArrowIcon.be68ae40.svg";